import { ModalForm, showModalForm } from '@components/modal-form';
import { useState } from 'preact/hooks';
import { parseVimeoUrl, buildVimeoEmbed } from './index';
import { autoFocusSelf } from 'client/utils/autofocus';

function VimeoModalContent() {
  const [error, setError] = useState('');

  return (
    <ModalForm
      title="Insert Vimeo Video"
      confirmButtonText="Insert Video"
      onSubmit={(data: any) => {
        const parsed = parseVimeoUrl(data.url || '');
        if (!parsed) {
          setError(
            "That isn't a Vimeo video link. Paste the video's Vimeo address or its embed code.",
          );
          return Promise.reject();
        }
        return Promise.resolve({ content: buildVimeoEmbed(parsed.id, parsed.hash) });
      }}
    >
      <input
        type="text"
        name="url"
        placeholder="Vimeo address or embed code"
        class="rounded-sm border-gray-300 w-full"
        ref={(el) => autoFocusSelf(el)}
        onInput={() => {
          if (error) {
            setError('');
          }
        }}
      />
      {error && <p class="text-red-600 text-sm mt-1">{error}</p>}
    </ModalForm>
  );
}

export function showVimeoModal() {
  return showModalForm<{ content: string }>(() => <VimeoModalContent />);
}
